import React from 'react';

import { ComponentProps } from '@/lib/types/shared/page.types';
import { DefaultPageProps } from '@/lib/types/shared/page.types';
import { extendedPathnames, usePathname } from '@/lib/navigation';
import { route } from '@/lib/navigationFunctions';
import { getBreadcrumbArray } from '@/lib/helpers/sharedHelper';

type Props = {
    replaceLastLink?: string | null | undefined;
} & DefaultPageProps & ComponentProps;

type PathBreadcrumb = {
    path: string;
    name: string;
}

export default function Breadcrumb({ replaceLastLink, className = '', params }: Props) {
    const currentLocale = params.locale;
    // const t = useTranslations('shared.pathnames');
    const currentPath = usePathname().replace(/\/$/, '');

    const handledArray: PathBreadcrumb[] = [];
    if (!currentPath) {

    } else {
        const pathKey = Object.keys(extendedPathnames).find(key => extendedPathnames[key].en === currentPath || extendedPathnames[key].nl === currentPath);
        const breadcrumbArray = getBreadcrumbArray(pathKey ?? '', extendedPathnames);
        // console.dir(breadcrumbArray, { depth: null });
        for (const key in breadcrumbArray) {
            const routePath = breadcrumbArray[key]['en'];
            const item = breadcrumbArray[key][currentLocale];
            // console.log(item);
    
            if (item === '/') {
                handledArray.push({ path: routePath, name: 'Home' });
            } else {
                const splittedPath = item.split('/');
                let path = splittedPath[splittedPath.length - 1];
                path = path.replace('/', '');
                path = path.replace(/-/g, ' ');
                path = path.replace(/\b\w/g, char => char.toUpperCase());
                handledArray.push({ path: routePath, name: path });
            }
        }
    }

    return (
        <div>
            {handledArray && handledArray.length > 0 ? (
                handledArray.map((item, index) => (
                    <React.Fragment key={index}>
                        {index === handledArray.length - 1 ? (
                            <span className={`${process.env.NEXT_APP_PERFORMANCE === 'true' ? 'text-white font-semibold' : 'text-secondary-700'} ${className}`}>
                                {item.name}
                            </span>
                        ) : (
                            <a href={route(item.path, params.locale)} title={item.name} aria-label={item.name} className={`underline ${process.env.NEXT_APP_PERFORMANCE === 'true' ? 'text-white font-semibold' : 'text-secondary-700'} ${className}`}>
                                {item.name}
                            </a>
                        )}
    
                        {index < handledArray.length - 1 && (
                            <span className={`mx-1 ${process.env.NEXT_APP_PERFORMANCE === 'true' ? 'text-white font-semibold' : 'text-secondary-700'}`}>{'/'}</span>
                        )}
                    </React.Fragment>
                ))
            ) : (
                <span className={`opacity-0 pointer-events-none select-none ${process.env.NEXT_APP_PERFORMANCE === 'true' ? 'text-white font-semibold' : 'text-secondary-700'} ${className}`}>
                    {'Home'}
                </span>
            )}
        </div>
    )
}
